export const EMAILS = {
  ersInquiries: 'inquiries@ers-cat.com',
};
